import { render } from "./User.vue?vue&type=template&id=01728535&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=01728535&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01728535"

export default script